export const appendLogs = (logs: string[], newLogs: string[]) => {
    const maxLogs = 500;

    const clampedLogs = [...logs, ...newLogs];

    return clampedLogs.length <= maxLogs ? clampedLogs : clampedLogs.slice(clampedLogs.length - maxLogs);
};
